var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    transform: "translate(1578 4178)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1578 -4178)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.667,2a3.75,3.75,0,0,0-3,1.5,3.75,3.75,0,0,0-6.75,2.25c0,4.494,6.244,8.038,6.506,8.188A.487.487,0,0,0,8.667,14a.474.474,0,0,0,.244-.062,19.643,19.643,0,0,0,3.219-2.35c2.181-1.962,3.288-3.925,3.288-5.837A3.75,3.75,0,0,0,11.667,2Z",
    transform: "translate(1578.083 4178)",
    fill: "#da4167"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIconSmall);
export default __webpack_public_path__ + "static/media/favorite-icon-small.9d07f08789b5481840fb24c0c8c462b9.svg";
export { ForwardRef as ReactComponent };